var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseTemplate',[_c('div',{staticClass:"rewards-coming-soon"},[_c('img',{attrs:{"src":_vm.comingSoonImage,"alt":"Rewards Coming Soon"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }